import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FcInTransit } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FaArchive, FaUndo } from "react-icons/fa";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ViewBuyer = () => {
  const user = useSelector((store) => store.login.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();

  const handleCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert("Phone number is not available!");
    }
  };

  const query = useQuery();
  const paramValue = query.get("favorite");

  useEffect(
    () => {
      setLoading(true);
      if (paramValue) {
        performRequest("GET", `/favoriteBuyer/getFavoriteBuyerById/${id}`)
          .then((res) => {
            if (res.status === 200) {
              setData(res.data);
            } else {
              Toast("error", "Error while getting Lead!");
            }
            setLoading(false);
          })
          .catch((err) => {
            CustomErrorResponse(err);
          })
          .finally(() => setLoading(false));
      } else {
        performRequest("GET", `/buyerProfiles/getbuyerProfilesById/${id}`)
          .then((res) => {
            if (res.status === 200) {
              setData(res.data);
            } else {
              Toast("error", "Error while getting Lead!");
            }
            setLoading(false);
          })
          .catch((err) => {
            CustomErrorResponse(err);
          })
          .finally(() => setLoading(false));
      }
    },
    [id, paramValue],
    refresh
  );

  if (loading) {
    return <LoadingPage />;
  }

  const addBuyerArchiveList = (status) => {
    performRequest("PATCH", `/buyerProfiles/updateArchivebuyerProfiles/${id}`, {
      archiveBuyer: status,
    })
      .then((res) => {
        if (res.status === 200) {
          if (!data?.archiveBuyer) {
            alert(
              "Buyer archived successfully. They are no longer visible to the client."
            );
            setRefresh(!refresh);
            navigate("/buyers-management");
          } else {
            alert(
              "Buyer unarchived successfully. They are now visible to the client."
            );
            setRefresh(!refresh);
            navigate("/buyers-management");
          }
        } else {
          Toast("error", "Error Archive Buyers Profiles");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcInTransit className="fs-2  me-1" /> Buyers Details
                </h2>
                <h4 className="text-muted">Details of {data?.name}.</h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <ul>
                  <li>
                    <strong>Disclaimer:</strong> Kryzen Biotech Private Limited
                    is not directly or indirectly part of the transaction
                    happening between you and this buyer.
                  </li>
                  <li className="mt-2">
                    Always send a small quantity of produce to start the
                    transaction.
                  </li>
                  <li className="mt-2">
                    Try to work with an advance payment or payment on
                    dispatch/delivery.
                  </li>
                  <li className="mt-2">
                    Avoid credit periods, unless you have transacted for more
                    than a month together.
                  </li>
                  <li className="mt-2">
                    Kryzen Biotech has accumulated this list via online and
                    offline platform and refined it based on available data.{" "}
                  </li>
                  <li className="mt-2">
                    This data is classified as list data and Kryzen Biotech has
                    no control over the business practices followed by
                    individual buyers.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specifications</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && data?.orderOrigin ? (
                        <>
                          <tr>
                            <td>Name of Buyer</td>
                            <td>{(data?.name || "N/A").toUpperCase()}</td>
                          </tr>
                          <tr>
                            <td>Phone Number of Buyer</td>
                            <td>
                              {(data?.phoneNumber1 || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Address of Buyer</td>
                            <td>
                              {(data?.addressLine1 || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>State of Buyer</td>
                            <td>
                              {(data?.addressState || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Pincode of Buyer</td>
                            <td>{data?.addressPincode || "N/A"}</td>
                          </tr>

                          <tr>
                            <td>Crop name</td>
                            <td>{data?.cropName?.toUpperCase() || "N/A"}</td>
                          </tr>

                          <tr>
                            <td>Crop photo</td>
                            <td>
                              <img
                                width="100px"
                                src={data?.cropPhoto}
                                alt={"CropPhoto"}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>Purcahse quantity</td>
                            <td>
                              {data?.purchaseQuantity
                                ? `${data?.purchaseQuantity} `
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td>Requirement Deadline</td>
                            <td>{data?.requirementDeadline?.toUpperCase() || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Pricing</td>
                            <td>{data?.pricing?.toUpperCase() || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Purchase frequency</td>
                            <td>{data?.purchaseFrequency?.toUpperCase() || "N/A"}</td>
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr>
                            <td>Name of Buyer</td>
                            <td>{(data?.name || "N/A").toUpperCase()}</td>
                          </tr>
                          <tr>
                            <td>Photo of Buyer</td>
                            <td>
                              {data?.photo ? (
                                <img
                                  src={data?.photo}
                                  alt={data?.name}
                                  style={{ width: "150px" }}
                                />
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Email of Buyer</td>
                            <td>{(data?.email || "N/A").toUpperCase()}</td>
                          </tr>
                          <tr>
                            <td>Phone Number of Buyer</td>
                            <td>
                              {(data?.phoneNumber1 || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Alternative Phone Number of Buyer</td>
                            <td>
                              {(data?.phoneNumber2 || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Address of Buyer</td>
                            <td>
                              {(data?.addressLine1 || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Market of Buyer</td>
                            <td>{(data?.market || "N/A").toUpperCase()}</td>
                          </tr>
                          <tr>
                            <td>State of Buyer</td>
                            <td>
                              {(data?.addressState || "N/A").toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Pincode of Buyer</td>
                            <td>{data?.addressPincode || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Fssai of Buyer</td>
                            <td>{data?.fssaiNumber.toUpperCase() || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Active Since of Buyer</td>
                            <td>{data?.yearEstablished || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Buyer Type</td>
                            <td>
                              {data?.isExporter && (
                                <span className="text-uppercase badge bg-cyan text-white m-1 ">
                                  Exporter
                                </span>
                              )}
                              {data?.isWholesaler && (
                                <span className="text-uppercase badge bg-cyan text-white m-1 ">
                                  Wholesaler
                                </span>
                              )}
                              {data?.isRetailer && (
                                <span className="text-uppercase badge bg-cyan text-white m-1 ">
                                  Retailer
                                </span>
                              )}
                              {data?.isTrader && (
                                <span className="text-uppercase badge bg-cyan text-white m-1 ">
                                  Trader
                                </span>
                              )}
                              {data?.isFoodProcessor && (
                                <span className="text-uppercase badge bg-cyan text-white m-1 ">
                                  Food Processor
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Deals In</td>
                            <td>
                              {data?.dealPerishableVegetables && (
                                <span className="text-uppercase badge bg-green text-white m-1 ">
                                  Perishable Items
                                </span>
                              )}
                              {data?.dealExoticVegetables && (
                                <span className="text-uppercase badge bg-green text-white m-1 ">
                                  Exotic Vegetables
                                </span>
                              )}
                              {data?.dealFruitsAndBerries && (
                                <span className="text-uppercase badge bg-green text-white m-1 ">
                                  Fruites & Berries
                                </span>
                              )}
                              {data?.dealDryFruits && (
                                <span className="text-uppercase badge bg-green text-white m-1 ">
                                  Dry Fruites
                                </span>
                              )}
                              {data?.dealGrains && (
                                <span className="text-uppercase badge bg-green text-white m-1 ">
                                  Grains
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Buyers rating</td>
                            <td>
                              {data?.buyerRating
                                ? data?.buyerRating / 2
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td>Google map link</td>
                            <td>
                              {data?.googleMapLink ? (
                                <a href={data?.googleMapLink}>
                                  {data?.googleMapLink}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Credit score</td>
                            <td>{data?.creditScore || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Delivery option</td>
                            <td>
                              {data?.deliveryRoad && (
                                <span className="text-uppercase badge bg-pink text-white m-1 ">
                                  By Road
                                </span>
                              )}
                              {data?.deliveryRail && (
                                <span className="text-uppercase badge bg-pink text-white m-1 ">
                                  By Rail
                                </span>
                              )}
                              {data?.deliverySea && (
                                <span className="text-uppercase badge bg-pink text-white m-1 ">
                                  By Sea
                                </span>
                              )}
                              {data?.deliveryCargo && (
                                <span className="text-uppercase badge bg-pink text-white m-1 ">
                                  By Cargo
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Monday</td>
                            <td>
                              {data?.openOnMonday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursMonday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Tuesday</td>
                            <td>
                              {data?.openOnTuesday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursTuesday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Wednesday</td>
                            <td>
                              {data?.openOnWednesday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursWednesday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Thursday</td>
                            <td>
                              {data?.openOnThursday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursThursday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Friday</td>
                            <td>
                              {data?.openOnFriday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursFriday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Saturday</td>
                            <td>
                              {data?.openOnSaturday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursSaturday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Operations on Sunday</td>
                            <td>
                              {data?.openOnSunday ? (
                                <span className="text-uppercase badge bg-yellow text-white me-1">
                                  Operational
                                </span>
                              ) : (
                                "Closed"
                              )}{" "}
                              {(
                                data?.operationalHoursSunday || "N/A"
                              ).toUpperCase()}
                            </td>
                          </tr>
                          <tr>
                            <td>Open for LTC</td>
                            <td>{data?.openForLtc ? "Yes" : "No"}</td>
                          </tr>
                          {data?.openForLtc && (
                            <tr>
                              <td>Crop name</td>
                              <td>{data?.cropName?.toUpperCase() || "N/A"}</td>
                            </tr>
                          )}
                          {data?.openForLtc && (
                            <tr>
                              <td>Crop photo</td>
                              <td>
                                <img
                                  width="100px"
                                  src={data?.cropPhoto}
                                  alt={"CropPhoto"}
                                />
                              </td>
                            </tr>
                          )}
                          {data?.openForLtc && (
                            <tr>
                              <td>Purcahse frequency</td>
                              <td>
                                {data?.purchaseFrequency || "N/A"}{" "}
                                {data?.purchaseFrequencyType || "N/A"}
                              </td>
                            </tr>
                          )}
                          {data?.openForLtc && (
                            <tr>
                              <td>Purcahse quantity</td>
                              <td>
                                {data?.purchaseQuantity
                                  ? `${data?.purchaseQuantity} kg`
                                  : "N/A"}
                              </td>
                            </tr>
                          )}
                          {data?.openForLtc && (
                            <tr>
                              <td>Pricing</td>
                              <td>
                                {data?.pricing ? `₹${data?.pricing}` : "N/A"}
                              </td>
                            </tr>
                          )}
                          {data?.openForLtc && (
                            <tr>
                              <td>LTC duration</td>
                              <td>
                                {data?.ltcDuration || "N/A"}{" "}
                                {data?.ltcDurationType || "N/A"}
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <div className="d-lg-none d-md-none">
                      <SimpleButton
                        buttonText="Call Now"
                        onClick={() =>
                          handleCall(data?.phoneNumber1 || data?.phoneNumber2)
                        }
                      />
                    </div>
                    {(user.Role ===
                      process.env.REACT_APP_ROLE_SALESCOORDINATOR ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                      <button
                        className="btn btn-primary mx-1 mt-2"
                        onClick={() =>
                          addBuyerArchiveList(
                            !data?.archiveBuyer ? true : false
                          )
                        }
                      >
                        <span>
                          {!data?.archiveBuyer ? (
                            <>
                              <FaArchive /> &nbsp;ARCHIVE
                            </>
                          ) : (
                            <>
                              <FaUndo /> &nbsp;RESTORE
                            </>
                          )}
                        </span>{" "}
                      </button>
                    )}

                    {(user.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      user.Role === process.env.REACT_APP_ROLE_MARKETING ||
                      user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                      <SimpleButton
                        buttonText="Edit Buyer"
                        onClick={() => {
                          if (paramValue) {
                            navigate(`/buyers-management/edit/${data.favId}`);
                          } else {
                            navigate(`/buyers-management/edit/${id}`);
                          }
                        }}
                      />
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewBuyer;
